/**
 * The observability and analytics hosts this app actually talks to.
 *
 * These live here, rather than inline at each SDK's init, because the CSP has to
 * allow exactly these origins (src/server.csp.ts). Review of EX-40884 caught the
 * policy restating vendor defaults while the app had been pointed at first-party
 * proxies -- a mismatch that produces false violations during the soak and breaks
 * analytics outright once the policy is enforced. One definition, imported by both
 * the SDK setup and the policy, is what stops that recurring.
 *
 * Keep this module free of imports: it is pulled into the server bundle by the
 * policy builder and into the client bundle by the SDK setup.
 */

/** Segment's loader and settings host -- a first-party proxy, not cdn.segment.com. */
export const SEGMENT_CDN_URL = 'https://sdks.paywithextend.com'

/**
 * Segment's event ingest. Carries a path because that is the shape the SDK's
 * `apiHost` option takes; the policy uses the origin.
 */
export const SEGMENT_API_HOST = 'sa.paywithextend.com/v1'

/** Mixpanel ingest -- also a first-party proxy. */
export const MIXPANEL_API_HOST = 'https://mx.paywithextend.com'

/** Datadog site. US1; determines the intake host below. */
export const DATADOG_SITE = 'datadoghq.com'

/**
 * Datadog's browser intake for RUM, browser logs, and session replay.
 *
 * Note this is a BARE host, not a subdomain of the site: a `*.` wildcard source
 * does not match it. Getting this wrong is self-concealing -- the RUM uploads
 * that carry our CSP violation reports would themselves be blocked, so the
 * reporter would be unable to tell us it was broken.
 */
export const DATADOG_INTAKE_ORIGIN = `https://browser-intake-${DATADOG_SITE}`
